import { chakra, forwardRef, type HTMLChakraProps } from '@chakra-ui/system';

import { DXF_Z_INDEX } from '../constants';

export const ToolLayer = forwardRef<HTMLChakraProps<'svg'>, 'svg'>(
  (props, ref) => (
    <chakra.svg
      ref={ref}
      position="absolute"
      inset={0}
      width="100%"
      height="100%"
      zIndex={DXF_Z_INDEX.SCENE_OVERLAY}
      // No interaction with the tool layer
      pointerEvents="none"
      overflow="visible"
      {...props}
    />
  ),
);
ToolLayer.displayName = 'ToolLayer';
